import Home from "../pages/home";
import Cartilha from "../pages/cartilha";
import CartilhaListagemPage from "../pages/cartilha/listagem";
import CartilhasOrgao from "../components/CartilhasOrgao";
export var Routes = {
    "/cartilha-listagem": CartilhaListagemPage,
    "/orgao/:sigla/cartilha/:idCartilha": Cartilha,
    "/orgao/:sigla": CartilhasOrgao,
    "/": Home,
};
